import type { GameCategoryKey } from "./categories";

/**
 * One short formative-check MCQ per category, shown on the round recap.
 * Purely educational - not scored. The first option is correct.
 */
export type RecapPrompt = {
  question: string;
  /** First entry is always the correct answer. */
  options: [string, string, string];
};

export const RECAP_PROMPTS: Record<GameCategoryKey, RecapPrompt> = {
  "noble-gas": {
    question: "What property do all noble gases share?",
    options: [
      "They have a full outer electron shell",
      "They are highly reactive metals",
      "They glow when heated",
    ],
  },
  halogen: {
    question: "How many valence electrons do halogens have?",
    options: ["7", "1", "8"],
  },
  "alkali-metal": {
    question: "Why are alkali metals stored under oil?",
    options: [
      "They react vigorously with air and water",
      "They rust slowly like iron",
      "They evaporate at room temperature",
    ],
  },
  "alkaline-earth": {
    question: "Which group are alkaline earth metals in?",
    options: ["Group 2", "Group 1", "Group 17"],
  },
  "transition-metal": {
    question: "Which block of the periodic table holds transition metals?",
    options: ["d-block", "s-block", "p-block"],
  },
  metalloid: {
    question: "Metalloids share properties with…",
    options: [
      "Both metals and nonmetals",
      "Only noble gases",
      "Only halogens",
    ],
  },
  nonmetal: {
    question: "Which is true of most nonmetals at room temperature?",
    options: [
      "Poor conductors of heat and electricity",
      "Shiny and malleable",
      "All are liquids",
    ],
  },
  lanthanide: {
    question: "Lanthanides span which atomic numbers?",
    options: ["57–71", "89–103", "21–30"],
  },
  actinide: {
    question: "What is true of most actinides?",
    options: [
      "They are radioactive",
      "They are noble gases",
      "They are nonmetallic",
    ],
  },
};
